<template></template>
<script>
import {ApiMonizze} from "../api-monizze";
import $ from 'jquery';

export default {
	props: {
		url: {
			type: String,
			required: true,
		},
		currentCustomer: {
			type: Number,
			required: true
		}
	},
	mounted() {
		$(document).on("click", ".track-action", this.trackAction);
	},
	beforeDestroy() {
		$(document).off("click", ".track-action", this.trackAction);
	},
	methods: {
		trackAction(event)
		{
			let taEvent = $(event.currentTarget).attr('data-ta-event') || null;
			let action = $(event.currentTarget).attr('data-ta-action') || null;
			let label = $(event.currentTarget).attr('data-ta-label') || null;
			let pageName = $(event.currentTarget).attr('data-ta-page-name') || null;
			let payloadAttr = $(event.currentTarget).attr('data-ta-payload') || null;
			let payload = {};

			if (payloadAttr) {
				payload = JSON.parse(payloadAttr);
			}

			if (taEvent === null || action === null || pageName === null) {
				return;
			}

			(new ApiMonizze).postDataFromApi(
				this.url,
				{
					event: taEvent,
					action: action,
					label: label,
					page_name: pageName,
					customer: this.currentCustomer,
					payload: payload,
				}, () => {
				}
			);
		},
	},
};
</script>
